import cloneDeep from 'lodash/cloneDeep'

export default {
    state: {
        priceTypes: [],
    },
    mutations: {
        setPriceTypes(state, priceTypes) {
            state.priceTypes = priceTypes
        },
        addPriceType(state, price) {
            state.priceTypes.push(price)
        },
        updatePriceType(state, price) {
            const index = state.priceTypes.findIndex(item => item.id === price.id)
            Vue.set(state.priceTypes, index, price)
        },
        removePriceType(state, priceId) {
            state.priceTypes = state.priceTypes.filter(item => item.id !== priceId)
        },
    },
    getters: {
        listPriceTypes: state => state.priceTypes,
        findPriceType: state => id => state.priceTypes.find(item => item.id === id)
    },
    actions: {
        loadPriceTypes(context, withTrashed = false) {
            const params = {
                with: ['localizations.locale,condition'],
            };

            if (withTrashed) {
                params.deleted = 'true'
            }

            const url = '/api/price-types?' + window.params(params);

            window.axios.get(url)
                .then(({ data }) => {
                    context.commit('setPriceTypes', data)
                })
                .catch(error => console.error(error))
        },
        addPriceType(context, payload) {
            context.commit('addPriceType', payload)
        },
        updatePriceType(context, payload) {
            context.commit('updatePriceType', payload)
        },
        removePriceType(context, userId) {
            context.commit('removePriceType', userId)
        },
    }
}
